import React, {useState} from 'react';
import {Col, Container, Row} from "react-bootstrap";
import IMG01 from "../../images/services/ls/Market-study-and-learning.webp";
import IMG02 from "../../images/services/ls/Development-&-experimentation.webp";
import IMG03 from "../../images/services/ls/Measurement-&-parameters.webp";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Technologysec(props) {
    const [activeTab, setActiveTab] = useState(1);

    function displayTab(tabNumber) {
        setActiveTab(tabNumber);
    }

    return (
        <>
            <div className="tekgriping_section p-100">
                <Container className="h-100">
                    <Row className="h-100">
                        <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                            <div className="example" data-text="solutions">
                                <h2>Our Forte</h2>
                            </div>
                            <p>Building startups differently</p>
                        </Col>
                        <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
                            <div className="tekgrip_flex">
                                <div className="tekgrip_title">
                                    <h5>90%
                                        <span>Startups fail</span></h5>
                                </div>
                                <div className="tekgrip_title">
                                    <h5>42%
                                        <span>Misleading demands</span></h5>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
                            <h3 onClick={() => {
                                displayTab(1)
                            }} className={`tabs ${activeTab === 1 ? 'active' : ''}`}>
                                <div className="tab_namee">Market study and learning</div>
                            </h3>

                            <h3 onClick={() => {
                                displayTab(2)
                            }} className={`tabs ${activeTab === 2 ? 'active' : ''}`}>
                                <div className="tab_namee">Development & experimentation</div>
                            </h3>

                            <h3 onClick={() => {
                                displayTab(3)
                            }} className={`tabs ${activeTab === 3 ? 'active' : ''}`}>
                                <div className="tab_namee">Measurement & parameters</div>
                            </h3>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="tekgrip_tabs_iamge tekrevol_dark_bg p-100">
                <Container className="h-100">
                    <Row className={activeTab === 1 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Market study and learning</h2>
                                <p>We begin with studying the market and understanding the market behavior and demands. By studying research papers, understanding consumer needs, market penetration capacities, and more, we ensure we get things right while laying the foundations. This phase sets the course for upcoming phases.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={IMG01}
                                    effect="blur" alt="Migration" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className={activeTab === 2 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Development & experimentation</h2>
                                <p>We start building the product with minimal features in the development and experimentation phase. This is also widely known as MVP or minimum viable product. It allows us to stay on the path without wasting much time and only to spend where necessary. The product gets perfected through multiple rounds.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image">
                                <LazyLoadImage
                                    src={IMG02}
                                    effect="blur" alt="Development" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className={activeTab === 3 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Measurement & parameters</h2>
                                <p>The lean startup process has an integral part. It requires continuous testing and measurement across multiple standards. By putting it to the test and letting the users experience the product, we identify the possibilities for improvement and repeat the process to improve the outcome. Our lean startup process defines what needs to be delivered.
                                </p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={IMG03}
                                    effect="blur" alt="Deployment" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}

export default Technologysec;